// extracted by mini-css-extract-plugin
export var scrollArea = "_no-0";